<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .notifications {
    width: 100%;
    height: 100%;

    .notification {
      display: flex;
      flex-direction: column;
      color: colors.get(systemError_100);
      background-color: colors.get(systemError_10);
      padding: utils.in_rem(8px);
      border-radius: 6px;
      text-align: left;

      .header {
        display: flex;
        align-items: center;
        gap: utils.in_rem(8px);
        margin-bottom: utils.in_rem(8px);
        font-weight: 600;
      }

      .warning-list {
        margin: 0;
        padding-left: utils.in_rem(24px);

        li {
          margin-bottom: utils.in_rem(8px);

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .show-affected {
        background: none;
        border: none;
        color: #007bff;
        cursor: pointer;
        text-decoration: underline;
        font: inherit;
        padding: 0;
        margin-top: utils.in_rem(8px);
        font-weight: 500;
        text-align: left;
        margin-left: 10px;
      }
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";

  let {
    outreachCount,
    noLicensesCount,
    showAffectedUsersButton,
    onclick = () => {},
    filterAffectedUsers = false,
  } = $props();

  let warningHeader = $derived.by(() => {
    if (outreachCount > 0 && noLicensesCount === 0) {
      return "Before You Save, changes below may remove data";
    }

    if (outreachCount === 0 && noLicensesCount > 0) {
      return "Before You Save, changes below may deactivate users";
    }

    return "Before You Save, changes below may remove data or deactivate users";
  });
</script>

<div class="notifications">
  {#if outreachCount > 0 || noLicensesCount > 0}
    <div class="notification">
      <div class="header">
        <Icon class="fas fa-exclamation-circle color-systemError_100" />
        {warningHeader}
      </div>

      <ul class="warning-list">
        {#if outreachCount > 0}
          <li>
            Removing the outreach license will result in the deletion of
            scheduled outreach and to dos. ({outreachCount}
            {outreachCount === 1 ? "user" : "users"})
          </li>
        {/if}

        {#if noLicensesCount > 0}
          <li>
            Removing all licenses will deactivate these users when changes are
            saved. They will no longer have access to the platform ({noLicensesCount}
            {noLicensesCount === 1 ? "user" : "users"})
          </li>
        {/if}
      </ul>

      {#if showAffectedUsersButton}
        <button type="button" class="show-affected" {onclick}>
          {filterAffectedUsers ? "Remove filter" : "Show affected users"}
        </button>
      {/if}
    </div>
  {/if}
</div>
